"use client";import{jsxs as e,jsx as t}from"react/jsx-runtime";import{twMerge as a,twJoin as s}from"tailwind-merge";import{useState as o}from"react";import{Typography as n}from"../../Base/Typography/Typography.js";import{Box as r}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";
/**
 * 목차 네비게이션을 표시하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array<{title: string, index: number}>} props.data - 목차 항목들의 배열 ({title, index}[])
 * @param {(index: number) => void} [props.onChange] - 목차 항목 선택 시 호출되는 콜백 함수
 * @param {number} [props.currentIndex=0] - 현재 선택된 목차의 인덱스
 * @param {string} [props.className] - 컴포넌트에 적용할 추가 클래스명
 *
 * @example
 * ```tsx
 * const items = [
 *   { title: '소개', index: 0 },
 *   { title: '시작하기', index: 1 },
 *   { title: '사용방법', index: 2 }
 * ];
 *
 * <TableOfContents
 *   data={items}
 *   currentIndex={0}
 *   onChange={(index) => console.log(`선택된 항목: ${index}`)}
 * />
 * ```
 */const l=({data:l,onChange:i,currentIndex:d=0,className:m})=>{const[c,p]=o(void 0),u=e=>{if(e===d)return p(void 0);e>d&&p("down"),e<d&&p("up"),null==i||i(e)};/*#__PURE__*/
return e(r,{"data-testid":"design-system-table-of-contents",className:a("relative flex h-auto w-[140px] flex-col",m),children:[
/*#__PURE__*/t(r,{"data-testid":"design-system-table-of-contents--gray-bar",className:"absolute left-0 top-0 z-0 my-1.5 h-[calc(100%_-_12px)] w-0.5 bg-w-gray-100"}),l.map((o=>{const{title:l,index:i}=o,m=d==i;/*#__PURE__*/
return e(r,{"data-testid":m?"design-system-table-of-contents--item-selected":"design-system-table-of-contents--item",className:a("relative flex h-9 w-full select-none items-center text-w-gray-400",m&&"text-w-gray-600"),onClick:()=>null==u?void 0:u(i),children:[
/*#__PURE__*/t("span",{"data-testid":m?"design-system-table-of-contents--bar-selected":"design-system-table-of-contents--bar",className:a("absolute -top-[6px] left-0 z-10 h-6 w-0.5 bg-transparent",m&&"bg-primary",m&&(e=>`transition duration-500 ease-out ${"down"===e?"translate-y-1/2":"top-1/2 -translate-y-1/2"}`)(c))}),
/*#__PURE__*/t(n,{variant:"body3",className:s("cursor-pointer pl-[18px]",m&&"font-medium"),children:l})]},i)}))]})};export{l as TableOfContents};
